import React from "react";
import Button from "./Button";
import {CloseSharp} from "@mui/icons-material";

export interface PopUpProps {
    onClose: (close: boolean) => void;
    title: string;
    children: React.ReactNode;
}

export const PopUp = (props: PopUpProps) => {
    return (
        <div className='popup-overlay'>
            <div className='popup-container'>
                <div className='row popup-header justify-content-end'>
                    <div className='col-10 text-center mt-1'>
                        { props.title }
                    </div>
                    <div className='col-1'>
                        <Button className='pop-up-btn' onClick={ () => props.onClose(false)}><CloseSharp/></Button>
                    </div>
                </div>
                <div className='popup-content'>
                    {props.children}
                </div>
            </div>
        </div>
    )
}